/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { withRouter } from 'react-router';
import classes from './CalculatedSensor.module.css';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import  FormulaBuilder from './FormulaBuilder';
import { connect,useDispatch } from 'react-redux';
import BobConfirmButton from '../../../components/BobConfirmButton';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import { enqueueSnackbar } from '../../../actions/applicationMessageActions';
import { setPageTitle } from '../../../helpers/auth';
import * as math from 'mathjs';
import NoSelectedSensorsScreen from '../../../components/NoSelectedSensorsScreen';
import BobModal from '../../../components/BobModal';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import SearchInput from '../../Global/SearchInput';
import { debounce, isEmpty } from 'lodash';

const FormulaForm = ({
    activeNavClient,
    activeNavEquipment,
    activeNavSite,
    agents,
    bobLoading,
    currentUser,
    setClonedFormula,
    fetchFormulaList,
    fetchCompanyFormulaList,
    formulaList,
    companyFormulaList,
    createSensorEvent,
    activeNavCompany,
    createFormula,
    activeFormula,
    fetchFormulaDetails,
    setNewFormula,
    system,
    updateFormula,
    deleteFormula,
    ...props
}) => {
    const dispatch = useDispatch();
    const [mode, setMode] = useState('k2a');
    const [editorVisible, setEditorVisible] = useState(false);
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [tempFormula, setTempFormula] = useState({});
    const [cloneMode, setCloneMode] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredFormulas, setFilteredFormulas ] = useState([]);
    const text = useRef(' ');
    const variableList = ['A', 'B'];
    useEffect(() => {
        const init = async () => {
            let company = '00000000-0000-0000-0000-000000000000';
            let promises = [fetchFormulaList(company,{})];
            promises.push = [fetchCompanyFormulaList(activeNavCompany.id, {})];
            Promise.all(promises.map(p => p.catch(err => err)));
            let mode = currentUser.isSuperUser ? 'k2a' : 'company';
            setMode(mode);
            setNewFormula();
        };
          
        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        if (formulaList && formulaList.length > 0) {
            setFilteredFormulas([...formulaList]);
        }
    }, [formulaList]);

    
    useEffect(() => {
        if (system) {
            setPageTitle(system.name + ' - Calculated Sensor', null);
        }
    }, [system]);

    useEffect(() => {
        if (activeNavEquipment.name) {
            setPageTitle(activeNavEquipment.name + ' - Calculated Sensor', null);
        }
    }, [activeNavEquipment.name]);

    const loadFormula = (formula) => {
        setCloneMode(false);
        setEditorVisible(true);
        let mode =  formula.companyId === '00000000-0000-0000-0000-000000000000' ? 'k2a' : 'company';
        setMode(mode);
        const options = {
            formulaId:     formula.id,
            companyId:     formula.companyId,
            effectiveDate: formula.effectiveTimestamp
        };
        let promises = [fetchFormulaDetails(options)];
        Promise.all(promises.map(p => p.catch(err => err)));
    };

    const handleSearch = async searchTerm => {
        setSearchTerm(searchTerm);

        if (isEmpty(searchTerm)) {
            setFilteredFormulas([...formulaList]);
        } else {
            const filteredSensors = formulaList.filter(sensor => sensor.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredFormulas([...filteredSensors]);
        }
    };

    const getStringFromHTMLFormula = ()=>{
        let text = '';
        let input = document.querySelector('#formula-editor');
        if (input) {
            for (let i=0; i<input.childNodes.length; i++) {
                if (input.childNodes[i].tagName && input.childNodes[i].tagName.toLowerCase() === 'input') {
                    text += input.childNodes[i].value;              
                }
                else {
                    text += input.childNodes[i].textContent;
                }
            }
            text = text.replace(/(\r\n|\n|\r)/gm, '').trim();
        }
        return text;
    };

    const syncTitle = (val)=>{
        text.current = val;
    };

    const handleBackClick = ()=>{
    };

    const handleConfirmation = ()=>{
        setConfirmationOpen(false);
    };

    const submitFormula = ()=>{
        handleConfirmation();
        loadFormula(tempFormula);
    };

    const openConfirmation = (formula) => {
        let text = isFormulaChanged();
        if (text) {
            setTempFormula(formula);
            setConfirmationOpen(true);
        } else {
            loadFormula(formula);
        }
    };

    const handleCancel = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setMode('k2a');
        setEditorVisible(false);
        setNewFormula();
    };

    const handleNewFormula = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setMode('k2a');
        setEditorVisible(true);
        setNewFormula();
    };

    const handleNewFormulaCompany = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setMode('company');
        setEditorVisible(true);
        setNewFormula();
    };

    const isFormulaChanged = () => {
        let ip = document.querySelector('#formula-editor');
        if (ip === null) {
            return false;
        }
        const template = getStringFromHTMLFormula();
        if (activeFormula && activeFormula.id) {
            return template !==  activeFormula.template ? true :false;
        }
        else if (template) {
            return true;
        }
        return false;
    };

    
    const fetchUserData = (actionType) => {
        switch (actionType) {
            case 'clone':
                cloneFormula(actionType);
                break;
            case 'enable':
                handleActive(actionType);
                break;
            case 'disable':
                handleActive(actionType);
                break;
            case 'delete':
                deActivateFormula();
                break;
            default:
                break;
        }
    };

    const deActivateFormula = () =>{
        const deleteFormula1 = async () => {
            if (activeFormula.id) {
                const options = {
                    formulaId:     activeFormula.id,
                    companyId:     activeFormula.companyId,
                    effectiveDate: activeFormula.effectiveTimestamp
                };
                if ( currentUser.isSuperUser) {
                    await deleteFormula(options);
                    let promises = [fetchFormulaList('00000000-0000-0000-0000-000000000000', {})];
                    promises.push = [fetchCompanyFormulaList(activeNavCompany.id,{})];
                    Promise.all(promises.map(p => p.catch(err => err)));
                }
            }
        };
        deleteFormula1();
    };

    const cloneFormula = (actionType)=>{
        setCloneMode(true);
        setClonedFormula();
    };

    const handleActive = (type) => {
        const template = getStringFromHTMLFormula();
        const save = async () => {
            let body = {
                'template':     template,
                'name':         text.current,
                'isSeeded':     mode === 'k2a'? true : false,
                'isSyndicated': false,
                'companyId':    '00000000-0000-0000-0000-000000000000',
                'status':       type === 'enable' ? 'Active' : 'Inactive'
            };

            if (body.name && body.template) {
                if (activeFormula.id) {
                    const options = {
                        formulaId:     activeFormula.id,
                        companyId:     '00000000-0000-0000-0000-000000000000',
                        effectiveDate: activeFormula.effectiveTimestamp
                    };
                    if ( currentUser.isSuperUser) {
                        await updateFormula(options, body);
                    }
                }
                let promises = [fetchFormulaList('00000000-0000-0000-0000-000000000000', {})];
                promises.push = [fetchCompanyFormulaList(activeNavCompany.id, {})];
                Promise.all(promises.map(p => p.catch(err => err)));
            }
            else {
                dispatch(enqueueSnackbar('Please fill the mandatory fields.', 'error'));
            }
        };

        save();  
    };

    const handleApply = () => {
        const template = getStringFromHTMLFormula();
        const save = async () => {
            let body = {
                'template':     template,
                'name':         text.current,
                'isSeeded':     mode === 'k2a'? true : false,
                'isSyndicated': mode === 'k2a'? true : false,
                'status':       'Active',
                'companyId':    mode === 'k2a' ? '00000000-0000-0000-0000-000000000000' : activeNavCompany.id
            };

            if (mode !== 'k2a') {
                delete body.isSeeded;
                let result = companyFormulaList.find(c => c.name === body.name);
                if (result) {
                    if (activeFormula.id && result.id !== activeFormula.id) {
                        dispatch(enqueueSnackbar('Formula already exists.', 'error'));
                        return;
                    }
                }
            }
            else {
                let result = formulaList.find(c => c.name === body.name);
                if (result) {
                    if (activeFormula.id && result.id !== activeFormula.id) {
                        dispatch(enqueueSnackbar('Formula already exists.', 'error'));
                        return;
                    }
                }
            }

            if (body.name && body.template) {
                if (activeFormula.id && !cloneMode) {
                    const options = {
                        formulaId:     activeFormula.id,
                        companyId:     currentUser && currentUser.isSuperUser ? '00000000-0000-0000-0000-000000000000' : activeNavCompany.id,
                        effectiveDate: activeFormula.effectiveTimestamp
                    };
                    
                    if (mode !== 'k2a') {
                        options.companyId = activeNavCompany.id;
                    }

                    if ( currentUser.isSuperUser) {
                        await updateFormula(options, body);
                    }
                    else  await createFormula(body);
                }
                else { 
                    await createFormula(body);
                }
                let promises = [fetchFormulaList('00000000-0000-0000-0000-000000000000', {})];
                promises.push = [fetchCompanyFormulaList(activeNavCompany.id, {})];
                Promise.all(promises.map(p => p.catch(err => err)));
            }
            else {
                dispatch(enqueueSnackbar('Please fill the mandatory fields.', 'error'));
            }
        };

        save();  
    };

    useEffect(() => {
        setEditorVisible(false);
    }, [createSensorEvent]);

    const handleTestConfirmation = () => {
        let scope = {
            A: 1,
            B: 2,
            C: 3,
            D: 2,
            E: 4,
            F: 5,
            G: 6,
            H: 7,
            I: 8,
            J: 9,
            K: 10,
            L: 11,
            M: 12,
            N: 13,
            O: 14,
            P: 15,
            Q: 16,
            R: 17,
            S: 18,
            T: 19,
            U: 20,
            V: 21,
            W: 22,
            X: 23,
            Y: 24,
            Z: 25
        };

        for (let key of Object.keys(scope)) {
            scope[key.toLocaleLowerCase()] = scope[key];
        }
        
        let variables = [];
        let template = getStringFromHTMLFormula();
        template = template.replace(/\u00A0/g, '');

        try {
            let templates = template.split('=');
            for (let i = 0; i < templates.length ; i++) {
                let tempFormula =  templates[i].replaceAll('avg', 'mean');
                tempFormula = tempFormula.replaceAll('Math.', '');
                let result = math.evaluate(tempFormula, scope);
            }
            dispatch(enqueueSnackbar('Calculation tested successfully.', 'success'));
        } catch (e) {
            dispatch(enqueueSnackbar('Expression is not valid.', 'error'));
        }
    };

    return (
        <React.Fragment>
            <div className={`calculated-sensor ${classes.CalculationContainer}`}>
                <div className={classes.FormulaForm}>
                    <div className={classes.TemplateCol}>
                        <Accordion defaultExpanded={true} className={classes.accordion}>
                            <AccordionSummary
                                className={classes.accordionSummary}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <div style={{width: '100%'}}>
                                    K2A Formulas
                                    {currentUser && currentUser.isSuperUser ?
                                        <span
                                            role="button" 
                                            onClick={handleNewFormula} 
                                            title=" Create New K2A Formula"
                                            style={{float: 'right',color: '#666666',cursor: 'pointer'}} 
                                            className="material-icons-outlined"
                                        >
                                            add
                                        </span>
                                        :
                                        ''
                                    }
                                    <div className={`${classes.SearchContainer} ${'search-accordion'}`} style={{marginBottom: 10}}>
                                        <SearchInput
                                            key={new Date()}
                                            className={classes.SearchInput}
                                            stopPropagation={true}
                                            search={debounce(handleSearch, 400)}
                                            placeholder={`Search`}
                                            value={searchTerm}
                                        />
                                    </div>
                                </div>
                            </AccordionSummary>
                            {formulaList && formulaList.length > 0 ?
                                <AccordionDetails className={classes.AccordionContent}>
                                    {filteredFormulas.map((c, i) => 
                                        <span key={i} className={'calc-menu-span'}>
                                            <span
                                                role="button" key={c.name} tabIndex={0}
                                                onClick={() => openConfirmation(c)}
                                                className={'calc-menu-span-label'}
                                                style={{curspor: 'pointer'}}
                                            >
                                                {c.name} 
                                            </span>
                                            {currentUser && currentUser.isSuperUser ?
                                                <BobTableContextMenu
                                                    type="Formula"
                                                    entityData={props.dataItem}
                                                    loadFormula = {loadFormula.bind(c)}
                                                    formula={c}
                                                    onFetch={(requestData, actionType) => fetchUserData(requestData, actionType)}
                                                />
                                                :
                                                ''
                                            }
                                        </span>  
                                    )}
                                </AccordionDetails>
                                :
                                ''
                            }
                        </Accordion>
                    </div>
                    <div className={classes.Formulabuilder} >
                        {editorVisible?
                            <FormulaBuilder mode="formula" syncTitle={syncTitle} />
                            :
                            <NoSelectedSensorsScreen
                                style={{
                                    width:      '80%',
                                    margin:     '0',
                                    marginLeft: '1rem',
                                    borderLeft: '1px solid #eeeff0'
                                }}
                                message="Please select an existing formula or create a new formula to continue."
                                height={'calc(100vh - 285px)'}
                            />
                        }
                    </div>
                </div>
            </div>
            <div className={classes.ButtonContainer}>
                <BobConfirmButton
                    className={classes.Button}
                    style={{marginLeft: 15,float: 'right'}}
                    variant="contained"
                    disabled={!editorVisible}
                    onClick={handleCancel}
                >
                    Cancel
                </BobConfirmButton>  
                {activeFormula && activeFormula.id ?
                    <BobConfirmButton
                        className={classes.ButtonWithMargin} style={{marginLeft: 15}} isLoading={false}
                        disabled={!editorVisible}
                        onClick={handleApply} label={currentUser && currentUser.isSuperUser ? 'Apply & Close' : 'Save As'}
                    />
                    :
                    <BobConfirmButton
                        className={classes.ButtonWithMargin} style={{marginLeft: 15}} isLoading={false}
                        disabled={!editorVisible}
                        onClick={handleApply} label={'Apply & Close'}
                    />
                }
                <BobConfirmButton
                    className={classes.ButtonWithMargin} 
                    isLoading={false} 
                    disabled={!editorVisible}
                    onClick={handleTestConfirmation} 
                    label={'Test Calculation'}
                />
            </div>
            {confirmationOpen ?
                <BobModal
                    confirmText="Yes"
                    cancelText="No"
                    rootClass={'announcement-delete-modal formula-delete-modal'}
                    onCancel={handleConfirmation}
                    onClose={handleConfirmation}
                    onConfirm={submitFormula}
                    open={confirmationOpen}
                    title={'Formula Confirmation'}
                >
                    Your unsaved changes will be discarded. Are you sure you wish to continue?
                </BobModal>
                :
                ''
            }
        </React.Fragment>
    );
};

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents } = basAgent;

    return {
        activeNavEquipment: state.bob.activeNavEquipment,
        activeNavClient:    state.bob.activeNavClient,
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavSite:      state.bob.activeNavSite,
        agents:             Object.values(basAgents),
        bobLoading:         state.bob.bobLoading,
        formulaList:        state.dashboard.formulaList,
        companyFormulaList: state.dashboard.companyFormulaList,
        activeFormula:      state.dashboard.activeFormula,
        currentUser:        state.currentUser,
        createSensorEvent:  state.dashboard.createSensorEvent
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FormulaForm));
